import React from 'react';
import BannerAdUnit from '../AdUnit/Banner';
const DreamupSidebarPlacement = ()=>/*#__PURE__*/ React.createElement(BannerAdUnit, {
        width: "291px",
        height: "260px",
        realEstateId: "2f2231c2-d516-40f2-8921-74a3bf9905d1"
    });
DreamupSidebarPlacement.displayName = 'DreamupSidebarPlacement';
export default DreamupSidebarPlacement;

//# sourceMappingURL=DreamupSidebar.js.map